import { render, staticRenderFns } from "./StorageBadTakeout.vue?vue&type=template&id=3c98acc6&"
import script from "./StorageBadTakeout.vue?vue&type=script&lang=js&"
export * from "./StorageBadTakeout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports